import type { RouteRecordRaw } from 'vue-router'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createEfficiencyRoutes = (prefix: string, withNames: boolean): RouteRecordRaw[] => [
  {
    path: `${prefix}efficiency`,
    ...maybeRouteName(withNames, 'efficiency'),
    component: () => import('@/views/efficiency/EfficiencyOverview.vue'),
    ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
    meta: {
      title: '人效助手',
      permission: 'efficiency:overview:view',
      ...(!withNames ? { legacyTenantRedirect: true } : {}),
    }
  },
  {
    path: `${prefix}efficiency/requirement-time`,
    ...maybeRouteName(withNames, 'efficiency-requirement-time'),
    component: () => import('@/views/efficiency/EfficiencyTimeAnalysis.vue'),
    ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
    meta: {
      title: '上线时间分析',
      permission: 'efficiency:overview:view',
      ...(!withNames ? { legacyTenantRedirect: true } : {}),
    }
  },
  {
    path: `${prefix}efficiency/story-point-time`,
    ...maybeRouteName(withNames, 'efficiency-story-point-time'),
    component: () => import('@/views/efficiency/EfficiencyStoryPointAnalysis.vue'),
    ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
    meta: {
      title: '单位故事点时间分析',
      permission: 'efficiency:overview:view',
      ...(!withNames ? { legacyTenantRedirect: true } : {}),
    }
  },
  {
    path: `${prefix}efficiency/rankings`,
    ...maybeRouteName(withNames, 'efficiency-rankings'),
    component: () => import('@/views/efficiency/EfficiencyRanking.vue'),
    ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
    meta: {
      title: '赛道人效排名',
      permission: 'efficiency:ranking:view',
      ...(!withNames ? { legacyTenantRedirect: true } : {}),
    }
  }
]

const efficiencyRoutes: RouteRecordRaw[] = [
  ...createEfficiencyRoutes('t/:tenantCode/', true),
  ...createEfficiencyRoutes('', false),
]

export default efficiencyRoutes
